import { Suspense } from 'react';
import { ExternalLink } from '../ExternalLink';
import { StyledFooterLinks } from './elements';
import './TwoStepFooter.css';

type FooterLink = {
  href: string;
  text: string;
};

interface Props {
  cookieConsentButton?: React.ReactNode;
  linkData: FooterLink[];
  disclaimerText?: string;
  isTwoStep?: boolean;
}

export const FooterLinks = ({
  cookieConsentButton,
  linkData,
  disclaimerText,
  isTwoStep,
}: Props) =>
  isTwoStep ? (
    <div className="footer-links flex shrink-0 list-none flex-wrap items-center justify-start gap-y-3 min-[1366px]:justify-end">
      {linkData.map((link) => (
        <li key={link.href}>
          <Suspense>
            <ExternalLink className={'no-underline'} href={link.href}>
              {link.text}
            </ExternalLink>
          </Suspense>
        </li>
      ))}
      {cookieConsentButton && <li>{cookieConsentButton}</li>}

      {disclaimerText && <li>{disclaimerText}</li>}
    </div>
  ) : (
    <StyledFooterLinks>
      {linkData.map((link) => (
        <li key={link.href}>
          <Suspense>
            <ExternalLink href={link.href}>{link.text}</ExternalLink>
          </Suspense>
        </li>
      ))}
      {cookieConsentButton && <li>{cookieConsentButton}</li>}
    </StyledFooterLinks>
  );
